import { render, staticRenderFns } from "./TournamentScheduleView.vue?vue&type=template&id=471e3263"
import script from "./TournamentScheduleView.vue?vue&type=script&lang=js"
export * from "./TournamentScheduleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports